import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorefrontStateService } from './storefront-state.service';
import { isStorefrontSellableProduct } from '../utils/product-storefront.util';

/**
 * Blocks /shop/* when the catalog has no active in-stock products (after ensureLoaded).
 * Keeps the Shop nav link and direct URLs aligned: no sellable products → no shop.
 */
export const storefrontHasProductsGuard: CanActivateFn = async () => {
  const storefront = inject(StorefrontStateService);
  const router = inject(Router);

  await storefront.ensureLoaded();
  if (storefront.getProducts().some(isStorefrontSellableProduct)) {
    return true;
  }
  return router.createUrlTree(['/']);
};
